'use client'

import React, { useEffect } from 'react'

import SiteHeaderWrapper from '@/components/SiteHeaderWrapper'
import TrustpilotSection from '@/components/TrustpilotSection'
import { brand } from '@/utils/brand'

import ShipplayReviewsPage from './ShipplayReviewsPage'

const LegacyReviewsPage: React.FC = () => {
  const { hero } = brand.pageContent.Reviews

  // Load Trustpilot widget script
  useEffect(() => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
    script.async = true
    document.head.appendChild(script)

    return () => {
      // Cleanup script when component unmounts
      const existingScript = document.querySelector(
        'script[src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"]',
      )
      if (existingScript) {
        existingScript.remove()
      }
    }
  }, [])

  return (
    <div className="bg-white">
      <SiteHeaderWrapper />

      <div className="relative bg-gray-900 py-24 lg:py-32">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40"
          style={{ backgroundImage: `url(${hero.backgroundImage})` }}
        />
        <div className="relative mx-auto max-w-7xl px-6 text-center">
          <h1 className="mb-4 text-3xl font-bold text-white lg:text-5xl">{hero.title}</h1>
          <p className="mb-8 text-lg text-white lg:text-xl">{hero.subtitle}</p>
        </div>
      </div>

      <TrustpilotSection />
    </div>
  )
}

const ReviewsPage: React.FC = () => {
  // Ship&Play brand uses the ported playground reviews page scaffold.
  // See ShipplayReviewsPage for details.
  if (brand.key === 'shipplay') {
    return <ShipplayReviewsPage />
  }

  return <LegacyReviewsPage />
}

export default ReviewsPage
